import { createAsyncThunk } from '@reduxjs/toolkit';

import { APIDataProvider, ApiPaths, TApiResponse } from '../../api';
import { ILimitation, IUserUsage } from '.';
import { IUser } from '../UserSlice';

interface ISaveUsage {
  userId: string;
  option: string;
}

interface IAccessLimit {
  usage: IUserUsage;
  limitation: ILimitation;
  lpAccess: boolean;
}

interface ISaveUserDetails {
  userId: string;
  email?: string;
  fullName: string;
  phoneNumber: string;
  country: string;
}

const apiDataProvider = new APIDataProvider();

export const getUsageByUserId = createAsyncThunk(
  'access/usage/get',
  async (userId: string) => {
    const response = await apiDataProvider.get<TApiResponse<IAccessLimit>>(
      `${ApiPaths.usages}/${userId}`
    );

    return response.data;
  }
);

export const saveUserUsage = createAsyncThunk(
  'access/usage/save',
  async (data: ISaveUsage) => {
    const response = await apiDataProvider.post<TApiResponse<IUserUsage>>(
      `${ApiPaths.usages}`,
      data
    );

    return response.data;
  }
);

export const saveUserDetails = createAsyncThunk(
  'access/userDetails/create',
  async (data: ISaveUserDetails) => {
    const response = await apiDataProvider.post<TApiResponse<IUser>>(
      `${ApiPaths.usages}/userDetails`,
      data
    );

    return response.data;
  }
);
